import Keycloak from 'keycloak-js';

export let isProd = ['app.tyro.school', 'new.tyro.school'].includes(
  window.location.hostname,
);

if (
  process.env.NODE_ENV === 'development' &&
  process.env.PUBLIC_AUTH_PROD === 'true'
) {
  isProd = true;
}

export const authConfig = new Keycloak({
  url: isProd ? 'https://auth.tyro.school' : 'https://kc.tyro-dev.com',
  realm: 'tyro',
  clientId: 'tyro-ui',
});

export function getAuthInstance() {
  return authConfig;
}

export async function acquireAuthToken() {
  try {
    await authConfig.updateToken();
    return authConfig.token ?? null;
  } catch (error) {
    await authConfig.login();
  }
}
